import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Response } from '../response';
import { CommonProvider } from '../common';

@Injectable()
export class PollProvider {

    constructor(public http: HttpClient, private commonService: CommonProvider) { }

    private _url: string = `${this.commonService.apiUrl}api/v1/poll`;

    getAll(): Observable<Response<Poll[]>> {
        return this.http.get<Response<Poll[]>>(this._url + '/list');
    }

    get(id: string): Observable<Response<Poll>> {
        return this.http.get<Response<Poll>>(this._url + `/${id}/show`);
    }

    create(post: PollCreate): Observable<Response<Poll>> {
        return this.http.post<Response<Poll>>(this._url + `/create`, post);
    }

    vote(id:string, vote: PollVote): Observable<Response<Poll>> {
        return this.http.post<Response<Poll>>(this._url + `/${id}/vote`, vote);
    }


}

export interface Poll {
    [x: string]: any;
    id: string;
    company_id?: string;
    post_id?: string;
    club_id?: string;
    user_id?: string;
    question?: string;
    enabled?: boolean;
    starts_at: number;
    ends_at: number;
    answered?: Array<any>;
    type?: number;
    createdAt?: string;
}

export interface PollShow {
    poll?: object;
    options?: object;
    answers?: object;
}

export interface PollVote{
    options?: Array<any>;
    answer_string?: string;
}

export interface PollCreate {
    question: string;
    options: Array<any>;
    enabled: boolean;
    starts_at: number;
    ends_at: number;
    type: string;
    isAnonym: boolean;
}


// WEBPACK FOOTER //
// ./src/providers/poll/poll.ts